<template>
    <div class="detail-container">
        <div class="f-row">
        <Breadcrumb separator=">" class="breadcrumb_zdy">
            当前位置:
            <BreadcrumbItem :to="{name: 'MergerList'}">数据</BreadcrumbItem>
            <BreadcrumbItem :to="{name: 'TenderList'}">招标采购列表页</BreadcrumbItem>
            <BreadcrumbItem>招标采购详情页</BreadcrumbItem>
        </Breadcrumb>
        </div>
        <div class="detail-area">
            <div class="detail-items">
                <div class="detail-item">
                    <div class="title">采购单位</div>
                    <div class="desc can-go" v-if="detail.project_entity_short_name" @click="goEntityDetail(detail.entity_uid, detail.project_entity_type)">{{detail.project_entity_short_name}}</div>
                    <div class="desc" v-else>{{detail.dw_name}}</div>
                    <div class="title">中标项目名称</div>
                    <div class="desc">{{detail.project_ele_name}}</div>
                </div>
                <div class="detail-item">
                    <div class="title">中标时间</div>
                    <div class="desc">{{detail.winning_bid_time | time_moment}}</div>
                    <div class="title">中标金额</div>
                    <div class="desc">{{parseFloat(detail.winning_bid_amount)}}万人民币</div>
                </div>
                <div class="detail-item">
                    <div class="title">中标单位</div>
                    <div class="desc">
                        <span class="can-go" v-for="item in detail.winning_entity" :key="item.winning_bid_entity_name" @click="goEntityDetail(item.winning_bid_entity_uid, item.winning_bid_entity_type)">{{item.winning_bid_entity_name}}</span>
                    </div>
                    <div class="title">项目标签</div>
                    <div class="desc">
                        <span v-for="item in detail.project_ele_type" :key="item">{{item | dealName(meta.bidding_type)}}</span>
                    </div>
                </div>
            </div>
            <div class="detail-content">
                <p class="data-tip"><i class="iconfont">&#xe654;</i>
                    <span>
                    当前招标采购数据来自全国性的公开渠道，正在扩展更多地方性公开渠道。数据范围超过国内医疗信息化市场的10%，样本数据具有一定的代表性，我们将二次结构化处理后的数据提供给用户使用。
                    如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：17338335471
                    </span>
                </p>
                <p class="title">{{detail.project_name}}</p>
                <div v-html="content.content"></div>
            </div>
            <p class="title-p">相关招标采购</p>
            <Table :columns="listColumns" :data="listData"></Table>
        </div>
        <Spin fix v-if="detailLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>
<script>
import { biddingDetail } from '../../service'
import {
  get_meta
} from 'js/get_meta'
import filter from 'js/filter'
export default {
    inject: ['login'],
    mixins: [get_meta],
    data() {
        return {
            detailLoading: true,
            listColumns: [{
                title: '中标项目名称',
                width: 239,
                render: (h, params) => {
                    return h('a', {
                    on: {
                        click: () => {
                        this.goBiddingDetail(params.row.id)
                        }
                    },
                    class: {
                        'dec-clamp': true
                    }
                    }, params.row.project_ele_name)
                }
                },
                {
                title: '采购单位',
                width: 160,
                render: (h, params) => {
                    return (
                        (params.row.project_entity_short_name 
                        && (params.row.project_entity_type === '0'
                        || params.row.project_entity_type === '1'
                        || params.row.project_entity_type === '2'
                        || params.row.project_entity_type === '3'))?h('a', {
                        on: {
                            click: () => {
                            this.goEntityDetail(params.row.entity_uid, params.row.project_entity_type)
                            }
                        },
                        class: {
                            'dec-clamp': true
                        }
                        }, params.row.project_entity_short_name):h('span', params.row.dw_name)
                    )
                }
                },
                {
                title: '采购地区',
                width: 106,
                render: (h, params) => {
                    return h('span', filter.addressDeal(params.row.address_id, '2'))
                }
                },
                {
                title: '项目标签',
                width: 110,
                render: (h, params) => {
                    let temp_str = ''
                    for(let i = 0;i < params.row.project_ele_type.length; i++) {
                    if(i == 0) {
                        temp_str += filter.dealName(params.row.project_ele_type[i], this.meta.bidding_type)
                    } else {
                        temp_str = temp_str+'、'+filter.dealName(params.row.project_ele_type[i], this.meta.bidding_type)
                    }
                    }
                    return h('span', temp_str)
                }
                },
                {
                title: '中标金额',
                width: 134,
                render: (h, params) => {
                    return h('span', params.row.winning_bid_amount?parseFloat(params.row.winning_bid_amount)+'万人民币':'未透露')
                }
                },
                {
                title: '中标单位',
                width: 110,
                render: (h, params) => {
                    if(params.row.winning_entity.length != 0) {
                    let temp_arr = []
                    for(let i = 0;i < params.row.winning_entity.length; i++) {
                        if(params.row.winning_entity[i].winning_bid_entity_type == '0'
                        ||params.row.winning_entity[i].winning_bid_entity_type == '1'
                        ||params.row.winning_entity[i].winning_bid_entity_type == '2'
                        ||params.row.winning_entity[i].winning_bid_entity_type == '3'){
                            temp_arr.push(h('a',{
                            on: {
                                click: () => {
                                this.goEntityDetail(params.row.winning_entity[i].winning_bid_entity_uid, params.row.winning_entity[i].winning_bid_entity_type)
                                }
                            },
                            class: {
                                'dec-clamp': true
                            }
                            },  i == 0 ? params.row.winning_entity[i].winning_bid_entity_name:'、'+params.row.winning_entity[i].winning_bid_entity_name))
                        } else {
                            temp_arr.push(h('span',
                            i == 0 ? params.row.winning_entity[i].winning_bid_entity_name:'、'+params.row.winning_entity[i].winning_bid_entity_name))
                        }
                        
                    }
                    return h('div', temp_arr)
                    } else {
                    return h('span', '--')
                    }
                }
                },
                {
                title: '中标时间',
                // width: 100,
                render: (h, params) => {
                    return h('span', filter.time_moment(params.row.winning_bid_time,'YYYY-MM-DD'))
                }
                }
            ],
            listData: [],
            detail: {},
            content: ''
        }
    },
    methods: {
        async biddingDetail() {
            let res = await biddingDetail({
                "user_key":this.$store.state.user_key,
                "id": this.$route.params.id
            }, (err) => { this.$Message.error('请求错误！') })
            if(res.status == 'success') {
                this.listData = res.other
                this.detail = res.res[0]
                this.content = res.content[0]
                this.detailLoading = false
            } else {
                this.$Message.error(res.message)
            }
        },
        goBiddingDetail(id) {
            this.$router.replace({name: 'TenderDetail', params: { id: id }})
            this.detailLoading = true
            this.biddingDetail()
        },
        goEntityDetail(uid, type) {
            if (this.$store.state.user_key) {
                if (type == 2) {
                // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
                const {
                    href
                } = this.$router.resolve({
                    name: "PeoDetail",
                    params: {
                    uid: uid
                    }
                })
                window.open(href, '_blank')
                } else if (type == 1) {
                // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
                const {
                    href
                } = this.$router.resolve({
                    name: "OrgDetail",
                    params: {
                    uid: uid
                    }
                })
                window.open(href, '_blank')
                } else if (type == 0) {
                // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
                const {
                    href
                } = this.$router.resolve({
                    name: "CompanyDetail",
                    params: {
                    uid: uid
                    }
                })
                window.open(href, '_blank')
                } else if (type == 3) {
                // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
                const {
                    href
                } = this.$router.resolve({
                    name: "HospitalDetail",
                    params: {
                    uid: uid
                    }
                })
                window.open(href, '_blank')
                }
            } else {
                this.login()
            }
        }
    },
    created() {
        this.getMeta(['bidding_type'])
        this.biddingDetail()
    },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.detail-container
  padding: 16px 0 42px
  width 1200px
  margin: 0 auto
  position: relative
.detail-area
  margin: 16px auto 0
  width: 1000px
  .detail-items
    // box-shadow:0px 1px 0px 0px rgba(233,233,233,1)
    commonBgColor(#1F2330, #fff)
  .detail-item
    display: flex
    line-height: 22px
    font-size: 14px
    div
      display: flex
      align-items: center
    .title
      width: 110px
      padding: 14px 0
      commonBgColor(#2A2F42, #FFFAF5)
      justify-content: center
      font-weight: bold
      commonColor(#fff,#666)
    .desc
      padding: 14px 20px
      commonColor(#BCBDC1,#333)
      flex: 1
      span+span:before
        content: '、'
    .can-go
        &:hover
            cursor: pointer
            color: #FA7A50
    &+.detail-item
      border-top-width: 1px 
      border-top-style: solid
      commonBorderTopColor(#40444F,#e9e9e9)
  .detail-content
    margin-top: 16px
    padding: 34px 80px
    commonBgColor(#1F2330, #fff)
    .title
       font-size: 28px
       commonColor(#fff,#333)
       text-align:center
       font-weight:bold
    div
       font-size: 16px
       line-height: 28px
       commonColor(#fff,#333)
       margin-top: 26px
  .title-p
    margin: 30px 0 12px 0
    line-height:25px
    font-weight: bold
    font-size: 18px
    commonColor(#fff,#333)
.data-tip
  commonBgColor(#113056, #F2FAFF)
  commonColor(#E9E9EB, #666666)
  font-size: 12px
  line-height: 18px
  padding: 16px 20px
  display: flex
  align-items: center
  margin-bottom: 40px
  .iconfont
    color: #69c0ff
    font-size: 20px
    margin-right: 12px
    display: inline-block
</style>